import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

const qrPublicService = {
  async createSession(branchId, qrToken, { customerName, customerPhone, customerEmail, customerBirthday, customerAnniversary } = {}) {
    return apiClient.post(ENDPOINTS.QR_PUBLIC.CREATE_SESSION(branchId), {
      qrToken,
      customerName: customerName || null,
      customerPhone: customerPhone || null,
      customerEmail: customerEmail || null,
      customerBirthday: customerBirthday || null,
      customerAnniversary: customerAnniversary || null,
    });
  },

  async placeOrder(branchId, sessionToken, items, notes) {
    return apiClient.post(ENDPOINTS.QR_PUBLIC.PLACE_ORDER(branchId), {
      sessionToken,
      items,
      notes: notes || null,
    });
  },

  async getOrders(branchId, sessionToken) {
    return apiClient.get(ENDPOINTS.QR_PUBLIC.GET_ORDERS(branchId), {
      params: { sessionToken },
    });
  },

  async updateCustomerInfo(branchId, data) {
    return apiClient.put(ENDPOINTS.QR_PUBLIC.UPDATE_CUSTOMER_INFO(branchId), data);
  },
};

export default qrPublicService;
